import { Box, ButtonBase, Typography, alpha } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CheckCircle from '@mui/icons-material/CheckCircle';
import { ENTRY_MODES, EntryMode } from '@/utils/salesReport';

interface EntryModeToggleProps {
  value: EntryMode;
  onChange: (mode: EntryMode) => void;
}

/**
 * Günlük girişler ortalamaya katılsın mı — web POS "Raporlar"daki seçimle
 * aynı iki seçenek. Az seçenek olduğu için açılır liste değil kutu butonlar.
 */
const EntryModeToggle = ({ value, onChange }: EntryModeToggleProps) => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      flexWrap="wrap"
      alignItems="center"
      gap={1}
      role="radiogroup"
      aria-label={t('salesReport.entryMode.label')}
    >
      <Typography variant="body2" fontWeight={600} color="text.secondary">
        {t('salesReport.entryMode.label')}
      </Typography>
      {ENTRY_MODES.map((mode) => {
        const selected = value === mode;
        return (
          <ButtonBase
            key={mode}
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(mode)}
            sx={(theme) => ({
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              px: 1.5,
              py: 1,
              borderRadius: 1,
              border: '1px solid',
              borderColor: selected
                ? theme.palette.primary.main
                : theme.palette.divider,
              boxShadow: selected
                ? `0 0 0 1px ${theme.palette.primary.main}`
                : 'none',
              backgroundColor: selected
                ? alpha(theme.palette.primary.main, 0.08)
                : theme.palette.background.paper,
              color: selected
                ? theme.palette.primary.main
                : theme.palette.text.primary,
              fontWeight: selected ? 700 : 500,
              fontSize: 14,
              '&:hover': {
                borderColor: theme.palette.primary.main
              }
            })}
          >
            {t(`salesReport.entryMode.${mode}`)}
            {selected && <CheckCircle fontSize="small" color="primary" />}
          </ButtonBase>
        );
      })}
    </Box>
  );
};

export default EntryModeToggle;
